<template>
  <div id="map-container">
    <div id="map"></div>
  </div>
</template>
<script>
import * as L from 'mapbox.js'
import { mapState } from 'vuex'

export default {
  name: 'community-map',
  data: function () {
    return {
      map: null,
      markers: {'FCM': {}, 'TCM': {}, 'HCM': {}},
      mapCategory: null,
      lowData: '',
      mediumData: '',
      highData: ''
    }
  },
  computed: mapState([
    'communityList',
    'categories',
    'selectedMetricCategory'
  ]),
  mounted: function () {
    let southWest = L.latLng(50.695793, -188.291053)
    let northEast = L.latLng(71.484692, -129.218604)
    let bounds = L.latLngBounds(southWest, northEast)
    L.mapbox.accessToken = 'pk.eyJ1Ijoia2JvcmFzaCIsImEiOiJjajB6cW0wYTAwMm05MzJxZHBnZmxmZjNhIn0.4LSGfOYP20gxv--B5ds9qw'
    this.map = L.mapbox.map('map', null, {
      maxBounds: bounds,
      minZoom: 4
    }).setView([63.23, -151.57], 4)
    .addLayer(L.mapbox.styleLayer('mapbox://styles/mapbox/outdoors-v11'))

    // Save SVG Markers here
    this.lowData = `<svg width="20" height="20" v-if="lowData">
      <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />
    </svg>`

    this.mediumData = `<svg width="20" height="20" v-else-if="mediumData">
      <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />
      <path d="M 17 10 A 1 1 1 0 1 3 10" fill="black" />
    </svg>`

    this.highData = `<svg width="20" height="20" v-else-if="goodData">
      <circle cx="10" cy="10" r="9" stroke-width="1" stroke="black" fill="white" />
      <circle cx="10" cy="10" r="6" stroke-width="1" stroke="black" fill="black" />
    </svg>`

    this.initializeMarkers()
    this.redrawMap()
  },
  watch: {
    selectedMetricCategory: function () {
      this.redrawMap()
    },
    communityList: {
      handler: function () {
        this.redrawMap()
      },
      deep: true
    }
  },
  methods: {
    initializeMarkers: function () {
      var self = this

      for (let category of this.categories) {
        for (let i = 0; i < this.communityList.length; i++) {
          let community = this.communityList[i]

          let svg = null
          switch (parseInt(community[category.name])) {
            case 1:
              svg = this.lowData
              break
            case 2:
              svg = this.mediumData
              break
            case 3:
              svg = this.highData
          }

          let icon = L.divIcon({
            className: 'communityMarkerNotSelected',
            html: svg,
            iconSize: null,
            iconAnchor: null
          })

          let newMarker = L.marker([community.latitude, community.longitude], {
            icon: icon,
            title: community.name
          }).on('click', function () { self.communityClicked(i, community) })
            .on('mouseover', function () { this.openTooltip() })
            .on('mouseout', function () { this.closeTooltip() })
            .bindTooltip(community.name)

          this.markers[category.name][community.name] = newMarker
        }
      }
    },
    redrawMap: function () {
      // TODO: Add debounce support to redrawing the map.
      // This might actually not be needed. It seems to perform fine right now.

      // Check for the current metric category
      if (this.selectedMetricCategory === null) {
        return
      }

      let redrawAllCommunities = false

      if (this.mapCategory === null) {
        redrawAllCommunities = true
      } else if (this.mapCategory.name !== this.selectedMetricCategory.name) {
        for (let communityName in this.markers[this.mapCategory.name]) {
          this.map.removeLayer(this.markers[this.mapCategory.name][communityName])
        }
        redrawAllCommunities = true
      }

      for (let i = 0; i < this.communityList.length; i++) {
        let marker = this.markers[this.selectedMetricCategory.name][this.communityList[i].name]
        let desiredClass = this.communityList[i].selected ? 'communityMarkerSelected' : 'communityMarkerNotSelected'
//        console.log(i + ' ' + desiredClass + ' ' + marker['options'].className + ' ' + (marker.options.className !== desiredClass))
        if (redrawAllCommunities === true || marker.options.icon.options.className !== desiredClass) {
          if (!redrawAllCommunities) {
            this.map.removeLayer(marker)
          }
          marker.options.icon.options.className = desiredClass
          marker.addTo(this.map)
          this.markers[this.selectedMetricCategory.name][this.communityList[i].name] = marker
        }
      }

      this.mapCategory = this.selectedMetricCategory
    },
    communityClicked: function (index, community) {
      if (!community.selected) {
        this.$store.dispatch('getMetricsForCommunity', community)
      }
      this.$store.commit({
        type: 'communitySelected',
        index: index,
        selected: !community.selected
      })
    }
  }
}
</script>
<style>
  #map {
    height: inherit;
  }

  #map-container {
    height: inherit;
  }

  .communityMarkerSelected {
    opacity: 1.0;
  }

  .communityMarkerSelected svg circle{
    stroke: green;
    stroke-width: 2;
  }

  .communityMarkerNotSelected {
    opacity: .5;
  }
</style>



// WEBPACK FOOTER //
// CommunityMap.vue?51061cdf